<div class="comment-container">
    <div class="comment">
        <div class="comment-head">
            <div class="avatar">
                <img src="assets/images/comments/user-avatar.svg" alt="Avatar">
            </div>
            <div class="username">{{comment.createdBy}}</div>
        </div>
        <div class="message" [innerHTML]="comment.message"></div>
        <div class="reactions-container">
            <div class="reactions">
                <div class="like">
                    <img src="assets/images/comments/{{(isLiked) ? 'liked' : 'like'}}.svg" (click)="onLike()"
                        (keydown.enter)="onLike()" (keydown.space)="onLike()" alt="Like">
                    <span class="like-count">{{comment.likeCount}}</span>
                </div>
                <div class="dislike">
                    <img src="assets/images/comments/{{(isDisliked) ? 'disliked' : 'dislike'}}.svg"
                        (click)="onDislike()" (keydown.enter)="onDislike()" (keydown.space)="onDislike()" alt="dislike">
                    <span class="dislike-count">{{comment.disLikeCount}}</span>
                </div>
            </div>
            <div class="time-stamp">{{comment.createdOn | dateAgo}}</div>
        </div>
    </div>
    <div class="comment-footer">
        <div></div>
        <div class="reply">
            <div class="reply-head" (click)="toggleReply()" (keydown.enter)="toggleReply()"
                (keydown.space)="toggleReply()">
                <span>{{comment.replyCount}}</span> Replies
            </div>
            <div class="reply-body" [@showReply]="!isShowReply ? 'initial' : 'final'">
                <div class="reply-container">
                    <ng-container *ngFor="let reply of replies">
                        <app-reply-shared [reply]="reply" [dasboardName]="dasboardName"></app-reply-shared>
                    </ng-container>
                    <div class="reply-loader" *ngIf="isLoading">{{message}}</div>
                </div>
                <div class="reply-box-container">
                    <div class="reply-box">
                        <div class="letter-avatar">
                            <div class="name">
                                <span>{{shortName}}</span>
                            </div>
                        </div>
                        <div class="reply-box-input">
                            <quill-editor [(ngModel)]="htmlText" placeholder="Write a reply" [modules]="quillConfig1"
                                [styles]="{height: '44px'}" (onContentChanged)="onContentChanged($event)">
                            </quill-editor>
                        </div>
                        <button class="cb-btn-send" (click)="postReply()" [disabled]="!htmlText || isLoading">
                            <img src="assets/images/comments/send.svg" alt="send">
                        </button>
                    </div>
                </div>
            </div>
            <div>

            </div>
        </div>
    </div>
</div>